import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';
import css from './OwnerBlogTabEmptyState.module.css';

const OwnerBlogTabEmptyState = ({ className }) => (
  <div className={classNames(css.root, className)}>
    <div className={css.titleWrapper}>
      <h2 className={css.title}>
        <FormattedMessage
          id="StoreProfilePage.tabs.blog.ownerEmpty.storeBlogTitle"
          defaultMessage="Store Blog"
        />
      </h2>
      <span className={css.itemCount}>
        <FormattedMessage
          id="StoreProfilePage.tabs.blog.ownerEmpty.storeBlogPostsCount"
          defaultMessage="0 Posts"
        />
      </span>
    </div>

    <div className={css.contentWrapper}>
      <div className={css.art} aria-hidden="true">
        <i className={classNames('ri-article-line', css.artIcon)} />
      </div>
      <p className={css.description}>
        <FormattedMessage
          id="StoreProfilePage.tabs.blog.ownerEmpty.description"
          defaultMessage="Share tips, guides, and updates with your customers. Create and manage posts in Store Settings."
        />
      </p>
      <NamedLink name="StoreBlogPage" className={css.cta}>
        <FormattedMessage
          id="StoreProfilePage.tabs.blog.ownerEmpty.cta"
          defaultMessage="Go to Store Blog"
        />
        <i className={classNames('ri-arrow-right-up-line', css.ctaArrow)} aria-hidden />
      </NamedLink>
    </div>
  </div>
);

OwnerBlogTabEmptyState.propTypes = {
  className: PropTypes.string,
};

export default OwnerBlogTabEmptyState;
